// src/pages/atributos/EliminarTipoAtributo.js
import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'

function EliminarTipoAtributo({ mostrar, tipo, eliminar, cancelar }) {
	const [loading, setLoading] = useState(false)

	const handleClose = () => {
		cancelar()
	}

	const handleEliminar = async () => {
		setLoading(true)
		try {
			await eliminar()
		} catch (error) {
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	if (!tipo) return null

	const tieneValores = tipo.valores && tipo.valores.length > 0

	return (
		<Modal show={mostrar} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>
					<i className="fa fa-trash text-danger me-2"></i>
					Eliminar tipo de atributo
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					<i className="fa fa-exclamation-triangle me-2"></i>
					Está a punto de eliminar el tipo de atributo <strong>"{tipo.nombre}"</strong>.
				</Alert>

				{tieneValores && (
					<Alert variant="warning">
						<i className="fa fa-info-circle me-2"></i>
						Este tipo tiene <strong>{tipo.valores.length}</strong> valores que también serán eliminados:
						<div className="mt-2 d-flex flex-wrap gap-1">
							{tipo.valores.slice(0, 10).map((valor) => (
								<Badge key={valor.id} bg="secondary">{valor.nombre}</Badge>
							))}
							{tipo.valores.length > 10 && (
								<Badge bg="secondary">+{tipo.valores.length - 10} más</Badge>
							)}
						</div>
					</Alert>
				)}

				<p className="mb-0">
					Esta acción no se puede deshacer. ¿Está seguro que desea continuar?
				</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
					Cancelar
				</Button>
				<Button variant="danger" onClick={handleEliminar} disabled={loading}>
					{loading ? (
						<>
							<i className="fa fa-spinner fa-spin me-2"></i>
							Eliminando...
						</>
					) : (
						<>
							<i className="fa fa-trash me-2"></i>
							Eliminar
						</>
					)}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EliminarTipoAtributo